module.exports = __webpack_public_path__ + "static/media/1.aec42050.jpg";